import React, { Component, useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Attachment from './Attachment';
import "./ViewComponent.css";
import { DownloadOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import Hexapi from '../../utility/HexAPI/Hexapi';
import { useSelector } from 'react-redux';
import Loader from '../loader/Loader';



export const ViewComponent=(props)=> {
const[isAllowDownload,setisAllowDownload]=useState(false)
const[isQueryHitComplete,setisQueryHitComplete]=useState(false)
const[isloadingset,setisloadingset]=useState(false)
const[isdownload,setisdownload]=useState(true)
const [isDisableWatermark, setIsDisableWatermark] = useState(1)
const [filenameget,setfilename]=useState(null)
const[extensionget,setextensionget]=useState(null)
const[imageData,setImageData]=useState(null)
   
    const user = useSelector(state => state?.users?.data?.[""]?.[0]);
    const userid = user?.empid ? user?.empid : null
   const fetchdata=()=>{
    let obj = {
        'query':`[dbo].[HRApp_Droid_Proc_User_GetAttachmentRight]@UserID='{0}'`,
        'queryArr': [`${userid}`]
    }
    Hexapi(obj).then((resp)=>{

        if(resp[''][0].disablewatermark == 0){
            setIsDisableWatermark(0)
        }else{
            setIsDisableWatermark(1)
        }
        if(resp[""][0].allowdownload == 1){
            setisAllowDownload(true)
        }else{
           setisAllowDownload(false)
        }

        setisQueryHitComplete(true)
    })
   }


   useEffect(()=>{
    if(!userid) return
    if(!props.isViewModalOpen) return
fetchdata()
   },[userid,props.isViewModalOpen])



const downloadFile = () => {
  setisloadingset(true);

  let filename = props.filename || filenameget;
  const extension = extensionget

  const generateFilename = (passid, ext) => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, "0");
    return `Attachment_${passid}_${now.getFullYear().toString().slice(2)}${pad(
      now.getMonth() + 1
    )}${pad(now.getDate())}${pad(now.getHours())}${pad(
      now.getMinutes()
    )}${pad(now.getSeconds())}${ext}`;
  };

  if (!filename) {
    filename = generateFilename(props.passid, extension);
  }

  if (!filename.toLowerCase().endsWith(extension.toLowerCase())) {
    filename = `${filename}${extension}`;
  }

  const imageDataa = imageData;
  setTimeout(() => {
    const downloadLink = document.createElement("a");
    downloadLink.href = imageDataa;
    downloadLink.setAttribute("download", filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setisloadingset(false);
  }, 1000);
};


        return (
            <>
   {isloadingset && (
              <div className="loading-overlay">
                <Loader variant='info'/>
                   
              </div>
            )}

                {props.isViewModalOpen &&
                    <Modal  id="documentmodal" style={{  padding: "30px" , display:"flex"}}
                    animation={true}  fullscreen={true} centered show={ props.isViewModalOpen } onHide={props.closeModal}  >

                            <div style={{ borderTopLeftRadius:"10px", borderTopRightRadius:"10px", backgroundColor:"white", display: "flex", justifyContent: "end", alignContent: "center", padding: "6px", paddingRight:"6px", borderBottom: "1px solid #ddd" }}>
  {isAllowDownload &&  (
    <Tooltip title="Download">
      <Button
        style={{ textAlign: "end", border: "none", width: 40, height: 40, backgroundColor: "transparent", fontSize: "larger" }}
        onClick={() => downloadFile()}
         disabled={isdownload}
      >
        <b>
<DownloadOutlined style={{ fontSize: '20px' }} /></b>
      </Button>
    </Tooltip>
  )}
  <Tooltip title="Close">
    <Button
      style={{ textAlign: "end", border: "none", width: 40, height: 40, backgroundColor: "transparent", fontSize: "larger" }}
    >
      <CloseOutlined style={{ fontSize: '20px' }} onClick={props.closeModal} />
    </Button>
  </Tooltip>
</div>
                        <Modal.Body  style={{ paddingRight: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          // width: '100vw',
          overflow: 'hidden',
          touchAction: 'auto',
          userSelect: 'auto'}}
                        >
                            <div>
                                {(isQueryHitComplete && userid)  &&
                                    <Attachment  isDisableWatermark={isDisableWatermark} attID={props.passid} setisdownload={setisdownload} userid={userid} filename={props.filenames}  isYou="0" AttachmentCallback={(imageData)=>downloadFile(imageData)} isFileALlowDownload = {isAllowDownload} passId ={props.passid} setImageData={setImageData} setfilenameget={setfilename} setextensionget={setextensionget} isAttachmentModalOpen = {props.isViewModalOpen} />
                                }
                            </div>
                        </Modal.Body>
                    </Modal>
                }
            </>
        )

}